import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './icons';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VeeValidate from 'vee-validate';
import Chart from 'vue2-frappe';
import { i18n } from './i18n';
// import { Trans } from './plugins/Translation';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Element from 'element-ui';
import './styles/element-vars.scss';
import locale from 'element-ui/lib/locale/lang/es';
import {
    faShoppingCart,
    faEye,
    faPhoneAlt,
    faEnvelope,
    faHome,
    faUser,
    faUserPlus,
    faSignInAlt,
    faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';

library.add(faShoppingCart, faEye, faPhoneAlt, faEnvelope, faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt);

Vue.config.productionTip = false;

Vue.use(Element, {locale});
Vue.use(VeeValidate);
Vue.use(Chart);
// Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans);
Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app');
